import React from 'react';
import { Container, Card, Form, Row, Col, Button } from 'react-bootstrap';
import {useForm, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";

function Profil() {
    const { t, getLocales } = useLaravelReactI18n();
    const {user} = usePage().props;
    const {data, setData, post, processing,progress,transform, errors} = useForm(user ? {
        name: user.name,
        email: user.email,
        password: '' // add here
    } : {
        name: '',
        email: '',
        password: '' // add here
    });

    function handleChange(e) {
        const key = e.target.id;
        const value = e.target.value;
        setData({
            ...data,
            [key]: value,
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
            post(`/profil`, { forceFormData: true });
    }

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Card>
                    <Card.Header className={"d-flex justify-content-between"}>
                        <h5>{t('edit profile')}</h5>
                        <Button variant="primary" type="submit">
                            {t('save')}
                        </Button>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                Name
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.name ? 'is-invalid' : ''}
                                    placeholder="Enter name"
                                    id="name"
                                    type="text"
                                    value={data.name}
                                    onChange={handleChange}
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                Email
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.email ? 'is-invalid' : ''}
                                    placeholder="Enter email"
                                    id="email"
                                    type="email"
                                    value={data.email}
                                    onChange={handleChange}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </Col>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Form>
        </Container>
    );
}
export default Profil;
